<section id="top-bar" class="border-b border-gray-200 z-50 flex justify-between w-full p-6 transition-all">
  <div class="flex flex-col gap-1 min-w-0 flex-1">
    <div class="text-2xl font-semibold truncate">
      {{ header() }}
    </div>
    @if (description()) {
      <div class="flex text-sm description">
        {{ description() }}
      </div>
    }
  </div>
  <ng-container *ngTemplateOutlet="suffixSection" />
</section>

<ng-template #suffixSection>
  @if (user(); as user) {
    <div class="flex items-center gap-2">
      <a
        routerLink="/my-page"
        class="flex gap-2 items-center hover:bg-base-200 px-3 py-2 rounded-lg cursor-pointer transition-colors">
        <span class="icon-[material-symbols--person] text-xl"></span>
        <p class="text-sm font-semibold">{{ user.name }}</p>
      </a>
      <button (click)="logout()" class="btn btn-ghost btn-sm">
        <span class="icon-[material-symbols--logout] text-xl"></span>
        <p class="text-sm">로그아웃</p>
      </button>
    </div>
  }
</ng-template>
